export default {
  // 一级菜单
  'menu.Leads': 'Leads',
  'menu.My profile': 'Mein Profil',
  'menu.Modify Password': 'Passwort ändern',
  'menu.Lead details': 'Details zum Thema',
  'menu.Add Lead': 'Blei hinzufügen',
  'menu.Edit Lead': 'Blei bearbeiten',
  'menu.Opportunities': 'Chancen',
  'menu.Opportunitiy details': 'Details zur Gelegenheit',
  'menu.Setting': 'Einstellung',
  'menu.Add Subaccount List': 'Unterkontenliste hinzufügen',
  'menu.Add AddSubaccount': 'Hinzufügen AddSubaccount',
  'menu.Edit AddSubaccount': 'AddSubaccount bearbeiten',
  'menu.Setting.Opportunity Extension Settings': 'Einstellungen der Opportunity-Erweiterung',
  'menu.Setting.Account Setting': 'Kontoeinstellung',
  'menu.Setting.Role Setting': 'Rollen-Einstellungen',
  'menu.Setting.Organization Setting': 'Organisationseinstellungen',
  'menu.Entries': 'Einträge',
  // 一级菜单
  'menu.welcome': 'Welcome1',
  'menu.more-blocks': 'More Blocks1',
  'menu.home': 'Home1',
  'menu.admin': 'Admin1',
  'menu.admin.sub-page': 'Sub-Page1',
  'menu.login': 'Login1',
  'menu.register': 'Register1',
  'menu.register-result': 'Register Result1',
  'menu.dashboard': 'Dashboard1',
  'menu.dashboard.analysis': 'Analysis1',
  'menu.dashboard.monitor': 'Monitor1',
  'menu.dashboard.workplace': 'Workplace1',
  'menu.exception.403': '4031',
  'menu.exception.404': '4041',
  'menu.exception.500': '5001',
  'menu.form': 'Form1',
  'menu.form.basic-form': 'Basic Form1',
  'menu.form.step-form': 'Step Form1',
  'menu.form.step-form.info': 'Step Form(write transfer information)1',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)1',
  'menu.form.step-form.result': 'Step Form(finished)1',
  'menu.form.advanced-form': 'Advanced Form1',
  'menu.list': 'List1',
  'menu.list.table-list': 'Search Table1',
  'menu.list.basic-list': 'Basic List1',
  'menu.list.card-list': 'Card List1',
  'menu.list.search-list': 'Search List1',
  'menu.list.search-list.articles': 'Search List(articles)1',
  'menu.list.search-list.projects': 'Search List(projects)1',
  'menu.list.search-list.applications': 'Search List(applications)1',
  'menu.profile': 'Profile1',
  'menu.profile.basic': 'Basic Profile1',
  'menu.profile.advanced': 'Advanced Profile1',
  'menu.result': 'Result1',
  'menu.result.success': 'Success1',
  'menu.result.fail': 'Fail1',
  'menu.exception': 'Exception1',
  'menu.exception.not-permission': '4031',
  'menu.exception.not-find': '4041',
  'menu.exception.server-error': '5001',
  'menu.exception.trigger': 'Trigger1',
  'menu.account': 'Account1',
  'menu.account.center': 'Account Center1',
  'menu.account.settings': 'Account Settings1',
  'menu.account.trigger': 'Trigger Error1',
  'menu.account.logout': 'Logout1',
  'menu.editor': 'Graphic Editor1',
  'menu.editor.flow': 'Flow Editor1',
  'menu.editor.mind': 'Mind Editor1',
  'menu.editor.koni': 'Koni Editor1',
  'menu.InviteCode': 'Einladungscode',
  'menu.Activity': 'Aktivität',
  'menu.Activity.Invite Code': 'Einladungscode',
  'menu.Activity.Campaign Participation': 'Kampagnenteilnahme',
};
